import * as R from 'ramda';
import { LevelSpecification } from '../LevelSpecification';

export const sortLevels = R.sortWith<LevelSpecification>([R.descend(R.prop('level'))]);
